module.exports = __webpack_public_path__ + "static/media/noun-two-hearts-1927945-17234D.343bb2ec.svg";